import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { upAdv, advAdd, upgetAdv } from "@/api/Administration/advertisement"; // import  {advAdd} from "@/api/Administration/advertisement";

export default {
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;

    var validate = function validate(rule, value, callback) {
      if (value === '') {
        callback(new Error(_this.$t('pleaseInput')));
      } else if (/[A-Z\u4e00-\u9fa5]/.test(value)) {
        callback(new Error(_this.$t('cannotContainUppercaseChinese')));
      } else {
        callback();
      }
    };

    return {
      dialogFormVisible: false,
      titleNameKey: "",
      id: "",
      form: {
        adv_place_name: "",
        status: "1",
        adv_place_mark: ""
      },
      makeForm: {
        adv_place_name: "",
        status: "1",
        adv_place_mark: ""
      },
      rules: {
        adv_place_name: [{
          required: true,
          message: this.$t('pleaseInputAdName'),
          trigger: "blur"
        }],
        adv_place_mark: [{
          required: true,
          validator: validate,
          trigger: "blur"
        }]
      },
      formLabelWidth: "120px"
    };
  },
  created: function created() {},
  computed: {
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  },
  methods: {
    // 打开修改新增
    init: function init(id, num) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tid, _yield$upgetAdv, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogFormVisible = true;

                if (num == 1) {
                  _this2.titleNameKey = "addAdPlacement";
                }

                _this2.id = id;

                if (!(id != "t")) {
                  _context.next = 14;
                  break;
                }

                if (!(num == 2)) {
                  _context.next = 14;
                  break;
                }

                _this2.titleNameKey = "modifyAdPlacement";
                tid = {
                  id: id
                };
                _context.next = 9;
                return upgetAdv(tid);

              case 9:
                _yield$upgetAdv = _context.sent;
                data = _yield$upgetAdv.data;
                _this2.form.status = String(data.status);
                _this2.form.adv_place_mark = data.adv_place_mark;
                _this2.form.adv_place_name = data.adv_place_name;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 关闭弹窗或取消修改新增
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.form = _objectSpread({}, this.makeForm);
      this.$emit("changeShow", false);
      this.$refs.ruleForm.clearValidate();
    },
    // 确定添加修改
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this3 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (vali) {
        if (vali) {
          //通过判断titleNameKey是添加还是修改来调用相应的接口
          if (_this3.titleNameKey == "addAdPlacement") {
            _this3.form.id = null;
            advAdd(_this3.form).then(function (res) {
              if (res.status == 200) {
                Message.success(_this3.$t('operationSuccess'));

                _this3.$emit("refreshDataList");

                _this3.resetForm("ruleForm");
              }
            });
          }

          if (_this3.titleNameKey == "modifyAdPlacement") {
            _this3.form.id = _this3.id;
            upAdv({
              adv_place_name: _this3.form.adv_place_name,
              adv_place_mark: _this3.form.adv_place_mark,
              id: _this3.form.id,
              status: String(_this3.form.status)
            }).then(function (res) {
              if (res.status == 200) {
                Message.success(_this3.$t('operationSuccess'));

                _this3.$emit("refreshDataList");

                _this3.resetForm("ruleForm");
              }
            });
          }
        }
      });
    }
  }
};